<script>

import Timeline from './components/Timeline'
import Login from './components/Login'
import Navigation from './components/Navigation'
import Credentials from './components/Credentials'

export default {
  components: {
    Login,
    Timeline,
    Navigation
  },

  data() {
    return {
      didLogin: false,
      isModalActive: false
    }
  },

  methods: {
    onLogout() {
      Credentials.set(null)
      location.reload()
    }
  },

  computed: {
    hasCredentials() {
      return this.didLogin || !!Credentials.get()
    }
  }
}
</script>

<template>

  <section class="hero is-fullheight">

    <b-modal :active.sync="isModalActive" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <div class="media">
              <div class="media-left">
                <b-icon icon="credit-card-wireless" size="is-large">
                </b-icon>
              </div>
              <div class="media-content">
                <p class="title is-4">RFID Reader</p>
                <p class="subtitle is-6">@MOQO</p>
              </div>
          </div>

          <div class="content">
            If you want to read a certain RFID tag, just place it on the Invers Dev-Kits card reader. If you refresh the page afterwards, you will see RFID tags that have recently been read.
          </div>
        </div>
      </div>
    </b-modal>

    <navigation v-if="hasCredentials" @logout="onLogout" @clickUser="isModalActive = true"></navigation>

    <div class="hero-body">
      <div class="container has-text-centered">

        <div v-if="hasCredentials">
          <h1 class="title">RFID Events</h1>
          <timeline></timeline>
        </div>

        <div v-else>
          <login @success="didLogin = true"></login>
        </div>

      </div>
    </div>
  </section>

</template>

<style lang="scss">
nav .column button{
  margin: 20px;
}
</style>
